import { apiKeys, apiRequest } from ".";
import {
  CreateConnectionProps,
} from "../../types/link";

export const createConnection = ({
  authForm,
  connectionDefinitionId,
  requestId,
  linkHeaders,
}: CreateConnectionProps) =>
  apiRequest({
    url: apiKeys["connection.create"],
    method: "POST",
    payload: {
      authForm,
      connectionDefinitionId,
      requestId,
    },
    withCredentials: linkHeaders?.["X-Pica-Use-Headers"] === "true"
  });


export const getConnectionDefinition = (definitionId: number, linkHeaders?: Record<string, unknown>) =>
  apiRequest({
    url: `${apiKeys["connection.definition"]}/${definitionId}`,
    method: "GET",
    payload: {},
    withCredentials: linkHeaders?.["X-Pica-Use-Headers"] === "true"
  });
